/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type Artifact = {
  __typename?: 'Artifact';
  createTime?: Maybe<Scalars['String']['output']>;
  dependencies?: Maybe<Array<Maybe<ArtifactDependency>>>;
  downloadable?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastRelease?: Maybe<Release>;
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  semver?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ArtifactDependency = {
  __typename?: 'ArtifactDependency';
  semver?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type ArtifactInput = {
  semver: Scalars['String']['input'];
  typeName: Scalars['String']['input'];
};

export type ArtifactType = {
  __typename?: 'ArtifactType';
  compatibleDevices?: Maybe<Array<Maybe<DeviceTypeName>>>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type ArtifactTypeList = {
  __typename?: 'ArtifactTypeList';
  types?: Maybe<Array<Maybe<ArtifactType>>>;
};

export type AssociateTagWithDeviceInput = {
  serialNumber: Scalars['String']['input'];
  tagId: Scalars['ID']['input'];
  tagName?: InputMaybe<Scalars['String']['input']>;
};

export type AssociateTagWithDeviceResponse = {
  __typename?: 'AssociateTagWithDeviceResponse';
  deviceTag?: Maybe<DeviceTag>;
};

export type CancelIotJobExecutionInput = {
  canopyDeviceId: Scalars['ID']['input'];
  jobId: Scalars['String']['input'];
};

export type CreateTagInput = {
  tagName: Scalars['String']['input'];
};

export type CreateTagResponse = {
  __typename?: 'CreateTagResponse';
  tag?: Maybe<Tag>;
};

export type DeleteTagInput = {
  tagId: Scalars['ID']['input'];
};

export type DeleteTagResponse = {
  __typename?: 'DeleteTagResponse';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletionResult = {
  __typename?: 'DeletionResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeployToDeviceInput = {
  canopyDeviceId: Scalars['String']['input'];
  deploymentId: Scalars['ID']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Deployment = {
  __typename?: 'Deployment';
  attempts?: Maybe<Array<Maybe<DeploymentAttempt>>>;
  consoleJobUrl?: Maybe<Scalars['String']['output']>;
  createTime?: Maybe<Scalars['String']['output']>;
  deploymentGroup?: Maybe<Scalars['String']['output']>;
  forceInstall?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  lastDeployedBy?: Maybe<Scalars['String']['output']>;
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  release?: Maybe<Release>;
  status?: Maybe<DeploymentStatus>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type DeploymentAttempt = {
  __typename?: 'DeploymentAttempt';
  deployedBy?: Maybe<Scalars['String']['output']>;
  forceInstall?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DeploymentInfoByDevice = {
  __typename?: 'DeploymentInfoByDevice';
  batteryLevel?: Maybe<Scalars['Int']['output']>;
  canopyDeviceId: Scalars['String']['output'];
  deployments?: Maybe<Array<DeviceDeployment>>;
  deviceReportedVersion?: Maybe<Scalars['String']['output']>;
  lastConnected?: Maybe<Scalars['String']['output']>;
  lifecycleState: Scalars['String']['output'];
  pendingOta?: Maybe<PendingOtaState>;
  vehicle?: Maybe<VimState>;
};

export type DeploymentInput = {
  forceInstall?: InputMaybe<Scalars['Boolean']['input']>;
  releaseId: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum DeploymentStatus {
  ACTIVE = 'active',
  CREATED = 'created',
  INACTIVE = 'inactive',
  STRATOSPHERE = 'stratosphere',
}

export type DeviceDeployment = {
  __typename?: 'DeviceDeployment';
  canopyDeviceId: Scalars['String']['output'];
  deploymentId: Scalars['ID']['output'];
  downloadStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  installStatus?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  states?: Maybe<DeviceDeploymentStates>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type DeviceDeploymentStates = {
  __typename?: 'DeviceDeploymentStates';
  download?: Maybe<Array<Maybe<DeviceDeploymentStatusEntry>>>;
  install?: Maybe<Array<Maybe<DeviceDeploymentStatusEntry>>>;
};

export type DeviceDeploymentStatusEntry = {
  __typename?: 'DeviceDeploymentStatusEntry';
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type DeviceTag = {
  __typename?: 'DeviceTag';
  canopyDeviceId?: Maybe<Scalars['ID']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['ID']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
};

export type DeviceType = {
  __typename?: 'DeviceType';
  typeName?: Maybe<DeviceTypeName>;
};

export type DeviceTypeList = {
  __typename?: 'DeviceTypeList';
  types?: Maybe<Array<Maybe<DeviceType>>>;
};

export enum DeviceTypeName {
  TRUCK = 'truck',
  VAN = 'van',
}

export type DisassociateTagFromDeviceInput = {
  serialNumber: Scalars['String']['input'];
  tagId: Scalars['ID']['input'];
};

export type DisassociateTagFromDeviceResponse = {
  __typename?: 'DisassociateTagFromDeviceResponse';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type GetDeviceTagsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  next?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetDeviceTagsResponse = {
  __typename?: 'GetDeviceTagsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<DeviceTag>>>;
};

export type GetSqlInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTagByNameResponse = {
  __typename?: 'GetTagByNameResponse';
  tagId: Scalars['ID']['output'];
  tagName: Scalars['String']['output'];
};

export type GetTagsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  next?: InputMaybe<Scalars['String']['input']>;
};

export type GetTagsResponse = {
  __typename?: 'GetTagsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<Tag>>>;
};

export type GroupedArtifactEntry = {
  __typename?: 'GroupedArtifactEntry';
  artifacts?: Maybe<Array<Maybe<Artifact>>>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type GroupedArtifacts = {
  __typename?: 'GroupedArtifacts';
  groups?: Maybe<Array<Maybe<GroupedArtifactEntry>>>;
};

export enum IotJobExecStatus {
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  QUEUED = 'QUEUED',
  REJECTED = 'REJECTED',
  REMOVED = 'REMOVED',
  SUCCEEDED = 'SUCCEEDED',
}

export type IotJobStatusInput = {
  canopyDeviceId: Scalars['ID']['input'];
  jobId: Scalars['String']['input'];
};

export type IotJobStatusResponse = {
  __typename?: 'IotJobStatusResponse';
  isCancellable: Scalars['Boolean']['output'];
  lastUpdatedAt: Scalars['String']['output'];
  status: IotJobExecStatus;
};

export type Mutation = {
  __typename?: 'Mutation';
  associateTagWithDevice?: Maybe<AssociateTagWithDeviceResponse>;
  cancelIotJobExecution?: Maybe<Scalars['String']['output']>;
  createArtifact: Artifact;
  createDeployment?: Maybe<Deployment>;
  createRelease: Release;
  createSQL?: Maybe<Scalars['Boolean']['output']>;
  createTag?: Maybe<CreateTagResponse>;
  deleteRelease: DeletionResult;
  deleteTag?: Maybe<DeleteTagResponse>;
  deployToDevice?: Maybe<Scalars['String']['output']>;
  disassociateTagFromDevice?: Maybe<DisassociateTagFromDeviceResponse>;
  promoteRelease: Scalars['String']['output'];
  sendStartInstallToDevice?: Maybe<Scalars['String']['output']>;
  setLatestApprovedVersion?: Maybe<Deployment>;
  setStableVersion?: Maybe<Scalars['String']['output']>;
  updateTag?: Maybe<UpdateTagResponse>;
};

export type MutationAssociateTagWithDeviceArgs = {
  input: AssociateTagWithDeviceInput;
};

export type MutationCancelIotJobExecutionArgs = {
  input: CancelIotJobExecutionInput;
};

export type MutationCreateArtifactArgs = {
  artifact: ArtifactInput;
};

export type MutationCreateDeploymentArgs = {
  deployment: DeploymentInput;
};

export type MutationCreateReleaseArgs = {
  release: ReleaseInput;
};

export type MutationCreateTagArgs = {
  input: CreateTagInput;
};

export type MutationDeleteReleaseArgs = {
  releaseId: Scalars['ID']['input'];
};

export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};

export type MutationDeployToDeviceArgs = {
  input: DeployToDeviceInput;
};

export type MutationDisassociateTagFromDeviceArgs = {
  input: DisassociateTagFromDeviceInput;
};

export type MutationPromoteReleaseArgs = {
  releaseId: Scalars['ID']['input'];
};

export type MutationSendStartInstallToDeviceArgs = {
  input: SendStartInstallToDeviceInput;
};

export type MutationSetLatestApprovedVersionArgs = {
  input: SetLatestApprovedVersionInput;
};

export type MutationSetStableVersionArgs = {
  input: SetStableVersionInput;
};

export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};

export type PaginatedArtifactList = {
  __typename?: 'PaginatedArtifactList';
  items?: Maybe<Array<Maybe<Artifact>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedDeploymentList = {
  __typename?: 'PaginatedDeploymentList';
  items?: Maybe<Array<Maybe<Deployment>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedDeviceDeploymentList = {
  __typename?: 'PaginatedDeviceDeploymentList';
  items?: Maybe<Array<Maybe<DeviceDeployment>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedReleaseList = {
  __typename?: 'PaginatedReleaseList';
  items?: Maybe<Array<Maybe<Release>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PendingOtaState = {
  __typename?: 'PendingOtaState';
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  getArtifact?: Maybe<Artifact>;
  getArtifactTypes: ArtifactTypeList;
  getArtifacts?: Maybe<PaginatedArtifactList>;
  getDeployment?: Maybe<Deployment>;
  getDeploymentInfoByDevice?: Maybe<DeploymentInfoByDevice>;
  getDeployments?: Maybe<PaginatedDeploymentList>;
  getDeviceDeployments?: Maybe<PaginatedDeviceDeploymentList>;
  getDeviceTags?: Maybe<GetDeviceTagsResponse>;
  getDeviceTypes: DeviceTypeList;
  getFieldDevicesTag?: Maybe<GetTagByNameResponse>;
  getGroupedArtifacts?: Maybe<GroupedArtifacts>;
  getIotJobStatus?: Maybe<IotJobStatusResponse>;
  getLatestApprovedVersion?: Maybe<Deployment>;
  getLatestDeployment?: Maybe<Deployment>;
  getRelease?: Maybe<Release>;
  getReleases?: Maybe<PaginatedReleaseList>;
  getSQL?: Maybe<Array<Maybe<Sql>>>;
  getStableVersion?: Maybe<Deployment>;
  getTagByName?: Maybe<GetTagByNameResponse>;
  getTags?: Maybe<GetTagsResponse>;
};

export type QueryGetArtifactArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetArtifactsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  typeName: Scalars['String']['input'];
};

export type QueryGetDeploymentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetDeploymentInfoByDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};

export type QueryGetDeploymentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  status: DeploymentStatus;
};

export type QueryGetDeviceDeploymentsArgs = {
  deploymentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetDeviceTagsArgs = {
  input: GetDeviceTagsInput;
};

export type QueryGetGroupedArtifactsArgs = {
  deviceType?: InputMaybe<DeviceTypeName>;
};

export type QueryGetIotJobStatusArgs = {
  input: IotJobStatusInput;
};

export type QueryGetReleaseArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetReleasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetSqlArgs = {
  input: GetSqlInput;
};

export type QueryGetTagByNameArgs = {
  tagName: Scalars['String']['input'];
};

export type QueryGetTagsArgs = {
  input: GetTagsInput;
};

export type Release = {
  __typename?: 'Release';
  artifacts?: Maybe<Array<Maybe<Artifact>>>;
  createTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceTypeName>;
  id?: Maybe<Scalars['ID']['output']>;
  isDeployed?: Maybe<Scalars['Boolean']['output']>;
  isLatestApproved?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isStable?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  releaseNotes?: Maybe<Scalars['String']['output']>;
  semver?: Maybe<Scalars['String']['output']>;
};

export type ReleaseInput = {
  artifactIds: Array<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceType: DeviceTypeName;
  releaseNotes?: InputMaybe<Scalars['String']['input']>;
  semver: Scalars['String']['input'];
};

export type Sql = {
  __typename?: 'SQL';
  childId?: Maybe<Scalars['String']['output']>;
  otherId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

export type SendStartInstallToDeviceInput = {
  canopyDeviceId: Scalars['ID']['input'];
  jobId: Scalars['String']['input'];
};

export type SetLatestApprovedVersionInput = {
  forceInstall?: InputMaybe<Scalars['Boolean']['input']>;
  releaseId: Scalars['ID']['input'];
};

export type SetStableVersionInput = {
  releaseId: Scalars['ID']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  tagId?: Maybe<Scalars['ID']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
};

export type UpdateTagInput = {
  tagId: Scalars['ID']['input'];
  tagName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTagResponse = {
  __typename?: 'UpdateTagResponse';
  tag?: Maybe<Tag>;
};

export type VimState = {
  __typename?: 'VIMState';
  isInMotion?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type Field = {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<InputValue>;
  type: Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type Type = {
  __typename?: '__Type';
  kind: TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByURL?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Field>>;
  interfaces?: Maybe<Array<Type>>;
  possibleTypes?: Maybe<Array<Type>>;
  enumValues?: Maybe<Array<EnumValue>>;
  inputFields?: Maybe<Array<InputValue>>;
  ofType?: Maybe<Type>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum TypeKind {
  /** Indicates this type is a scalar. */
  SCALAR = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  OBJECT = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  INTERFACE = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  UNION = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  ENUM = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  INPUT_OBJECT = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  LIST = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NON_NULL = 'NON_NULL',
}

export type CancelIotJobExecutionMutationVariables = Exact<{
  input: CancelIotJobExecutionInput;
}>;

export type CancelIotJobExecutionMutation = {
  __typename?: 'Mutation';
  cancelIotJobExecution?: string | null;
};

export type CreateDeploymentMutationVariables = Exact<{
  deployment: DeploymentInput;
}>;

export type CreateDeploymentMutation = {
  __typename?: 'Mutation';
  createDeployment?: {
    __typename?: 'Deployment';
    id?: string | null;
    jobId?: string | null;
  } | null;
};

export type CreateReleaseMutationVariables = Exact<{
  release: ReleaseInput;
}>;

export type CreateReleaseMutation = {
  __typename?: 'Mutation';
  createRelease: { __typename?: 'Release'; id?: string | null };
};

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;

export type CreateTagMutation = {
  __typename?: 'Mutation';
  createTag?: {
    __typename?: 'CreateTagResponse';
    tag?: {
      __typename?: 'Tag';
      tagId?: string | null;
      tagName?: string | null;
    } | null;
  } | null;
};

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;

export type UpdateTagMutation = {
  __typename?: 'Mutation';
  updateTag?: {
    __typename?: 'UpdateTagResponse';
    tag?: {
      __typename?: 'Tag';
      tagId?: string | null;
      tagName?: string | null;
    } | null;
  } | null;
};

export type DeleteTagMutationVariables = Exact<{
  input: DeleteTagInput;
}>;

export type DeleteTagMutation = {
  __typename?: 'Mutation';
  deleteTag?: { __typename?: 'DeleteTagResponse'; ok?: boolean | null } | null;
};

export type DeployToDeviceMutationVariables = Exact<{
  input: DeployToDeviceInput;
}>;

export type DeployToDeviceMutation = {
  __typename?: 'Mutation';
  deployToDevice?: string | null;
};

export type PromoteReleaseMutationVariables = Exact<{
  releaseId: Scalars['ID']['input'];
}>;

export type PromoteReleaseMutation = {
  __typename?: 'Mutation';
  promoteRelease: string;
};

export type SendStartInstallToDeviceMutationVariables = Exact<{
  input: SendStartInstallToDeviceInput;
}>;

export type SendStartInstallToDeviceMutation = {
  __typename?: 'Mutation';
  sendStartInstallToDevice?: string | null;
};

export type SetStableVersionMutationVariables = Exact<{
  input: SetStableVersionInput;
}>;

export type SetStableVersionMutation = {
  __typename?: 'Mutation';
  setStableVersion?: string | null;
};

export type GetDeploymentInfoByDeviceQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type GetDeploymentInfoByDeviceQuery = {
  __typename?: 'Query';
  getDeploymentInfoByDevice?: {
    __typename?: 'DeploymentInfoByDevice';
    canopyDeviceId: string;
    lifecycleState: string;
    batteryLevel?: number | null;
    lastConnected?: string | null;
    deviceReportedVersion?: string | null;
    deployments?: Array<{
      __typename?: 'DeviceDeployment';
      status: string;
      version?: string | null;
      jobId?: string | null;
      states?: {
        __typename?: 'DeviceDeploymentStates';
        download?: Array<{
          __typename?: 'DeviceDeploymentStatusEntry';
          status: string;
          updatedAt: string;
        } | null> | null;
        install?: Array<{
          __typename?: 'DeviceDeploymentStatusEntry';
          status: string;
          updatedAt: string;
        } | null> | null;
      } | null;
    }> | null;
    pendingOta?: {
      __typename?: 'PendingOtaState';
      version?: string | null;
      status?: string | null;
    } | null;
    vehicle?: {
      __typename?: 'VIMState';
      isInMotion?: boolean | null;
      updatedAt?: string | null;
    } | null;
  } | null;
};

export type GetDeploymentsQueryVariables = Exact<{
  status: DeploymentStatus;
}>;

export type GetDeploymentsQuery = {
  __typename?: 'Query';
  getDeployments?: {
    __typename?: 'PaginatedDeploymentList';
    items?: Array<{
      __typename?: 'Deployment';
      id?: string | null;
      status?: DeploymentStatus | null;
      createTime?: string | null;
      lastUpdateTime?: string | null;
      lastDeployedBy?: string | null;
      forceInstall?: boolean | null;
      release?: {
        __typename?: 'Release';
        semver?: string | null;
        createTime?: string | null;
        lastUpdateTime?: string | null;
        deviceType?: DeviceTypeName | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetDeploymentsMinQueryVariables = Exact<{
  status: DeploymentStatus;
}>;

export type GetDeploymentsMinQuery = {
  __typename?: 'Query';
  getDeployments?: {
    __typename?: 'PaginatedDeploymentList';
    items?: Array<{
      __typename?: 'Deployment';
      id?: string | null;
      jobId?: string | null;
      release?: { __typename?: 'Release'; semver?: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetDeploymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeploymentQuery = {
  __typename?: 'Query';
  getDeployment?: {
    __typename?: 'Deployment';
    createTime?: string | null;
    consoleJobUrl?: string | null;
    jobId?: string | null;
    forceInstall?: boolean | null;
    tags?: Array<string> | null;
    release?: {
      __typename?: 'Release';
      semver?: string | null;
      id?: string | null;
      deviceType?: DeviceTypeName | null;
      artifacts?: Array<{
        __typename?: 'Artifact';
        typeName?: string | null;
        semver?: string | null;
        dependencies?: Array<{
          __typename?: 'ArtifactDependency';
          typeName?: string | null;
          semver?: string | null;
        } | null> | null;
      } | null> | null;
    } | null;
    attempts?: Array<{
      __typename?: 'DeploymentAttempt';
      startTime?: string | null;
      deployedBy?: string | null;
      tags?: Array<string | null> | null;
      forceInstall?: boolean | null;
    } | null> | null;
  } | null;
};

export type GetDeviceDeploymentsQueryVariables = Exact<{
  deploymentId: Scalars['ID']['input'];
}>;

export type GetDeviceDeploymentsQuery = {
  __typename?: 'Query';
  getDeviceDeployments?: {
    __typename?: 'PaginatedDeviceDeploymentList';
    items?: Array<{
      __typename?: 'DeviceDeployment';
      id: string;
      deploymentId: string;
      canopyDeviceId: string;
      serialNumber: string;
      status: string;
      downloadStatus: string;
      installStatus?: string | null;
      updatedAt: string;
      states?: {
        __typename?: 'DeviceDeploymentStates';
        download?: Array<{
          __typename?: 'DeviceDeploymentStatusEntry';
          status: string;
        } | null> | null;
        install?: Array<{
          __typename?: 'DeviceDeploymentStatusEntry';
          status: string;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetDeviceTagsQueryVariables = Exact<{
  input: GetDeviceTagsInput;
}>;

export type GetDeviceTagsQuery = {
  __typename?: 'Query';
  getDeviceTags?: {
    __typename?: 'GetDeviceTagsResponse';
    count?: number | null;
    next?: string | null;
    prev?: string | null;
    results?: Array<{
      __typename?: 'DeviceTag';
      tagId?: string | null;
      canopyDeviceId?: string | null;
      serialNumber?: string | null;
      tagName?: string | null;
    } | null> | null;
  } | null;
};

export type AssociateTagWithDeviceMutationVariables = Exact<{
  input: AssociateTagWithDeviceInput;
}>;

export type AssociateTagWithDeviceMutation = {
  __typename?: 'Mutation';
  associateTagWithDevice?: {
    __typename?: 'AssociateTagWithDeviceResponse';
    deviceTag?: {
      __typename?: 'DeviceTag';
      tagId?: string | null;
      canopyDeviceId?: string | null;
      serialNumber?: string | null;
      tagName?: string | null;
    } | null;
  } | null;
};

export type DisassociateTagFromDeviceMutationVariables = Exact<{
  input: DisassociateTagFromDeviceInput;
}>;

export type DisassociateTagFromDeviceMutation = {
  __typename?: 'Mutation';
  disassociateTagFromDevice?: {
    __typename?: 'DisassociateTagFromDeviceResponse';
    ok?: boolean | null;
  } | null;
};

export type GetTagByNameQueryVariables = Exact<{
  tagName: Scalars['String']['input'];
}>;

export type GetTagByNameQuery = {
  __typename?: 'Query';
  getTagByName?: {
    __typename?: 'GetTagByNameResponse';
    tagId: string;
    tagName: string;
  } | null;
};

export type GetDeviceTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetDeviceTypesQuery = {
  __typename?: 'Query';
  __type?: {
    __typename?: '__Type';
    enumValues?: Array<{ __typename?: '__EnumValue'; name: string }> | null;
  } | null;
};

export type GetGroupedArtifactsQueryVariables = Exact<{
  deviceTypeName?: InputMaybe<DeviceTypeName>;
}>;

export type GetGroupedArtifactsQuery = {
  __typename?: 'Query';
  getGroupedArtifacts?: {
    __typename?: 'GroupedArtifacts';
    groups?: Array<{
      __typename?: 'GroupedArtifactEntry';
      typeName?: string | null;
      artifacts?: Array<{
        __typename?: 'Artifact';
        id?: string | null;
        semver?: string | null;
        typeName?: string | null;
        lastUpdateTime?: string | null;
        createTime?: string | null;
        lastRelease?: { __typename?: 'Release'; semver?: string | null } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetIotJobStatusQueryVariables = Exact<{
  input: IotJobStatusInput;
}>;

export type GetIotJobStatusQuery = {
  __typename?: 'Query';
  getIotJobStatus?: {
    __typename?: 'IotJobStatusResponse';
    status: IotJobExecStatus;
    lastUpdatedAt: string;
    isCancellable: boolean;
  } | null;
};

export type GetReleasesQueryVariables = Exact<{ [key: string]: never }>;

export type GetReleasesQuery = {
  __typename?: 'Query';
  getReleases?: {
    __typename?: 'PaginatedReleaseList';
    items?: Array<{
      __typename?: 'Release';
      id?: string | null;
      semver?: string | null;
      deviceType?: DeviceTypeName | null;
      isPromoted?: boolean | null;
      isLatestApproved?: boolean | null;
      isStable?: boolean | null;
      isDeployed?: boolean | null;
      artifacts?: Array<{
        __typename?: 'Artifact';
        semver?: string | null;
        typeName?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetStableVersionQueryVariables = Exact<{ [key: string]: never }>;

export type GetStableVersionQuery = {
  __typename?: 'Query';
  getStableVersion?: {
    __typename?: 'Deployment';
    id?: string | null;
    release?: { __typename?: 'Release'; semver?: string | null } | null;
  } | null;
};

export type GetTagsQueryVariables = Exact<{
  input: GetTagsInput;
}>;

export type GetTagsQuery = {
  __typename?: 'Query';
  getTags?: {
    __typename?: 'GetTagsResponse';
    count?: number | null;
    next?: string | null;
    prev?: string | null;
    results?: Array<{
      __typename?: 'Tag';
      tagId?: string | null;
      tagName?: string | null;
    } | null> | null;
  } | null;
};

export const CancelIotJobExecutionDocument = gql`
  mutation CancelIotJobExecution($input: CancelIotJobExecutionInput!) {
    cancelIotJobExecution(input: $input)
  }
`;
export type CancelIotJobExecutionMutationFn = Apollo.MutationFunction<
  CancelIotJobExecutionMutation,
  CancelIotJobExecutionMutationVariables
>;

/**
 * __useCancelIotJobExecutionMutation__
 *
 * To run a mutation, you first call `useCancelIotJobExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelIotJobExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelIotJobExecutionMutation, { data, loading, error }] = useCancelIotJobExecutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelIotJobExecutionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelIotJobExecutionMutation,
    CancelIotJobExecutionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelIotJobExecutionMutation,
    CancelIotJobExecutionMutationVariables
  >(CancelIotJobExecutionDocument, options);
}
export type CancelIotJobExecutionMutationHookResult = ReturnType<
  typeof useCancelIotJobExecutionMutation
>;
export type CancelIotJobExecutionMutationResult =
  Apollo.MutationResult<CancelIotJobExecutionMutation>;
export type CancelIotJobExecutionMutationOptions = Apollo.BaseMutationOptions<
  CancelIotJobExecutionMutation,
  CancelIotJobExecutionMutationVariables
>;
export const CreateDeploymentDocument = gql`
  mutation CreateDeployment($deployment: DeploymentInput!) {
    createDeployment(deployment: $deployment) {
      id
      jobId
    }
  }
`;
export type CreateDeploymentMutationFn = Apollo.MutationFunction<
  CreateDeploymentMutation,
  CreateDeploymentMutationVariables
>;

/**
 * __useCreateDeploymentMutation__
 *
 * To run a mutation, you first call `useCreateDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeploymentMutation, { data, loading, error }] = useCreateDeploymentMutation({
 *   variables: {
 *      deployment: // value for 'deployment'
 *   },
 * });
 */
export function useCreateDeploymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDeploymentMutation,
    CreateDeploymentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDeploymentMutation,
    CreateDeploymentMutationVariables
  >(CreateDeploymentDocument, options);
}
export type CreateDeploymentMutationHookResult = ReturnType<
  typeof useCreateDeploymentMutation
>;
export type CreateDeploymentMutationResult =
  Apollo.MutationResult<CreateDeploymentMutation>;
export type CreateDeploymentMutationOptions = Apollo.BaseMutationOptions<
  CreateDeploymentMutation,
  CreateDeploymentMutationVariables
>;
export const CreateReleaseDocument = gql`
  mutation CreateRelease($release: ReleaseInput!) {
    createRelease(release: $release) {
      id
    }
  }
`;
export type CreateReleaseMutationFn = Apollo.MutationFunction<
  CreateReleaseMutation,
  CreateReleaseMutationVariables
>;

/**
 * __useCreateReleaseMutation__
 *
 * To run a mutation, you first call `useCreateReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReleaseMutation, { data, loading, error }] = useCreateReleaseMutation({
 *   variables: {
 *      release: // value for 'release'
 *   },
 * });
 */
export function useCreateReleaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReleaseMutation,
    CreateReleaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReleaseMutation,
    CreateReleaseMutationVariables
  >(CreateReleaseDocument, options);
}
export type CreateReleaseMutationHookResult = ReturnType<
  typeof useCreateReleaseMutation
>;
export type CreateReleaseMutationResult =
  Apollo.MutationResult<CreateReleaseMutation>;
export type CreateReleaseMutationOptions = Apollo.BaseMutationOptions<
  CreateReleaseMutation,
  CreateReleaseMutationVariables
>;
export const CreateTagDocument = gql`
  mutation CreateTag($input: CreateTagInput!) {
    createTag(input: $input) {
      tag {
        tagId
        tagName
      }
    }
  }
`;
export type CreateTagMutationFn = Apollo.MutationFunction<
  CreateTagMutation,
  CreateTagMutationVariables
>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTagMutation,
    CreateTagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(
    CreateTagDocument,
    options,
  );
}
export type CreateTagMutationHookResult = ReturnType<
  typeof useCreateTagMutation
>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<
  CreateTagMutation,
  CreateTagMutationVariables
>;
export const UpdateTagDocument = gql`
  mutation UpdateTag($input: UpdateTagInput!) {
    updateTag(input: $input) {
      tag {
        tagId
        tagName
      }
    }
  }
`;
export type UpdateTagMutationFn = Apollo.MutationFunction<
  UpdateTagMutation,
  UpdateTagMutationVariables
>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTagMutation,
    UpdateTagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(
    UpdateTagDocument,
    options,
  );
}
export type UpdateTagMutationHookResult = ReturnType<
  typeof useUpdateTagMutation
>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<
  UpdateTagMutation,
  UpdateTagMutationVariables
>;
export const DeleteTagDocument = gql`
  mutation DeleteTag($input: DeleteTagInput!) {
    deleteTag(input: $input) {
      ok
    }
  }
`;
export type DeleteTagMutationFn = Apollo.MutationFunction<
  DeleteTagMutation,
  DeleteTagMutationVariables
>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTagMutation,
    DeleteTagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(
    DeleteTagDocument,
    options,
  );
}
export type DeleteTagMutationHookResult = ReturnType<
  typeof useDeleteTagMutation
>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<
  DeleteTagMutation,
  DeleteTagMutationVariables
>;
export const DeployToDeviceDocument = gql`
  mutation DeployToDevice($input: DeployToDeviceInput!) {
    deployToDevice(input: $input)
  }
`;
export type DeployToDeviceMutationFn = Apollo.MutationFunction<
  DeployToDeviceMutation,
  DeployToDeviceMutationVariables
>;

/**
 * __useDeployToDeviceMutation__
 *
 * To run a mutation, you first call `useDeployToDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployToDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployToDeviceMutation, { data, loading, error }] = useDeployToDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeployToDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeployToDeviceMutation,
    DeployToDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeployToDeviceMutation,
    DeployToDeviceMutationVariables
  >(DeployToDeviceDocument, options);
}
export type DeployToDeviceMutationHookResult = ReturnType<
  typeof useDeployToDeviceMutation
>;
export type DeployToDeviceMutationResult =
  Apollo.MutationResult<DeployToDeviceMutation>;
export type DeployToDeviceMutationOptions = Apollo.BaseMutationOptions<
  DeployToDeviceMutation,
  DeployToDeviceMutationVariables
>;
export const PromoteReleaseDocument = gql`
  mutation PromoteRelease($releaseId: ID!) {
    promoteRelease(releaseId: $releaseId)
  }
`;
export type PromoteReleaseMutationFn = Apollo.MutationFunction<
  PromoteReleaseMutation,
  PromoteReleaseMutationVariables
>;

/**
 * __usePromoteReleaseMutation__
 *
 * To run a mutation, you first call `usePromoteReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteReleaseMutation, { data, loading, error }] = usePromoteReleaseMutation({
 *   variables: {
 *      releaseId: // value for 'releaseId'
 *   },
 * });
 */
export function usePromoteReleaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PromoteReleaseMutation,
    PromoteReleaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PromoteReleaseMutation,
    PromoteReleaseMutationVariables
  >(PromoteReleaseDocument, options);
}
export type PromoteReleaseMutationHookResult = ReturnType<
  typeof usePromoteReleaseMutation
>;
export type PromoteReleaseMutationResult =
  Apollo.MutationResult<PromoteReleaseMutation>;
export type PromoteReleaseMutationOptions = Apollo.BaseMutationOptions<
  PromoteReleaseMutation,
  PromoteReleaseMutationVariables
>;
export const SendStartInstallToDeviceDocument = gql`
  mutation SendStartInstallToDevice($input: SendStartInstallToDeviceInput!) {
    sendStartInstallToDevice(input: $input)
  }
`;
export type SendStartInstallToDeviceMutationFn = Apollo.MutationFunction<
  SendStartInstallToDeviceMutation,
  SendStartInstallToDeviceMutationVariables
>;

/**
 * __useSendStartInstallToDeviceMutation__
 *
 * To run a mutation, you first call `useSendStartInstallToDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendStartInstallToDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendStartInstallToDeviceMutation, { data, loading, error }] = useSendStartInstallToDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendStartInstallToDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendStartInstallToDeviceMutation,
    SendStartInstallToDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendStartInstallToDeviceMutation,
    SendStartInstallToDeviceMutationVariables
  >(SendStartInstallToDeviceDocument, options);
}
export type SendStartInstallToDeviceMutationHookResult = ReturnType<
  typeof useSendStartInstallToDeviceMutation
>;
export type SendStartInstallToDeviceMutationResult =
  Apollo.MutationResult<SendStartInstallToDeviceMutation>;
export type SendStartInstallToDeviceMutationOptions =
  Apollo.BaseMutationOptions<
    SendStartInstallToDeviceMutation,
    SendStartInstallToDeviceMutationVariables
  >;
export const SetStableVersionDocument = gql`
  mutation SetStableVersion($input: SetStableVersionInput!) {
    setStableVersion(input: $input)
  }
`;
export type SetStableVersionMutationFn = Apollo.MutationFunction<
  SetStableVersionMutation,
  SetStableVersionMutationVariables
>;

/**
 * __useSetStableVersionMutation__
 *
 * To run a mutation, you first call `useSetStableVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStableVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStableVersionMutation, { data, loading, error }] = useSetStableVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetStableVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetStableVersionMutation,
    SetStableVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetStableVersionMutation,
    SetStableVersionMutationVariables
  >(SetStableVersionDocument, options);
}
export type SetStableVersionMutationHookResult = ReturnType<
  typeof useSetStableVersionMutation
>;
export type SetStableVersionMutationResult =
  Apollo.MutationResult<SetStableVersionMutation>;
export type SetStableVersionMutationOptions = Apollo.BaseMutationOptions<
  SetStableVersionMutation,
  SetStableVersionMutationVariables
>;
export const GetDeploymentInfoByDeviceDocument = gql`
  query GetDeploymentInfoByDevice($serialNumber: String!) {
    getDeploymentInfoByDevice(serialNumber: $serialNumber) {
      deployments {
        status
        version
        jobId
        states {
          download {
            status
            updatedAt
          }
          install {
            status
            updatedAt
          }
        }
      }
      canopyDeviceId
      lifecycleState
      batteryLevel
      lastConnected
      pendingOta {
        version
        status
      }
      deviceReportedVersion
      vehicle {
        isInMotion
        updatedAt
      }
    }
  }
`;

/**
 * __useGetDeploymentInfoByDeviceQuery__
 *
 * To run a query within a React component, call `useGetDeploymentInfoByDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentInfoByDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeploymentInfoByDeviceQuery({
 *   variables: {
 *      serialNumber: // value for 'serialNumber'
 *   },
 * });
 */
export function useGetDeploymentInfoByDeviceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDeploymentInfoByDeviceQuery,
    GetDeploymentInfoByDeviceQueryVariables
  > &
    (
      | { variables: GetDeploymentInfoByDeviceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDeploymentInfoByDeviceQuery,
    GetDeploymentInfoByDeviceQueryVariables
  >(GetDeploymentInfoByDeviceDocument, options);
}
export function useGetDeploymentInfoByDeviceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeploymentInfoByDeviceQuery,
    GetDeploymentInfoByDeviceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDeploymentInfoByDeviceQuery,
    GetDeploymentInfoByDeviceQueryVariables
  >(GetDeploymentInfoByDeviceDocument, options);
}
export function useGetDeploymentInfoByDeviceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeploymentInfoByDeviceQuery,
    GetDeploymentInfoByDeviceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeploymentInfoByDeviceQuery,
    GetDeploymentInfoByDeviceQueryVariables
  >(GetDeploymentInfoByDeviceDocument, options);
}
export type GetDeploymentInfoByDeviceQueryHookResult = ReturnType<
  typeof useGetDeploymentInfoByDeviceQuery
>;
export type GetDeploymentInfoByDeviceLazyQueryHookResult = ReturnType<
  typeof useGetDeploymentInfoByDeviceLazyQuery
>;
export type GetDeploymentInfoByDeviceSuspenseQueryHookResult = ReturnType<
  typeof useGetDeploymentInfoByDeviceSuspenseQuery
>;
export type GetDeploymentInfoByDeviceQueryResult = Apollo.QueryResult<
  GetDeploymentInfoByDeviceQuery,
  GetDeploymentInfoByDeviceQueryVariables
>;
export const GetDeploymentsDocument = gql`
  query GetDeployments($status: DeploymentStatus!) {
    getDeployments(status: $status, limit: 250) {
      items {
        id
        status
        release {
          semver
          createTime
          lastUpdateTime
          deviceType
        }
        createTime
        lastUpdateTime
        lastDeployedBy
        forceInstall
      }
    }
  }
`;

/**
 * __useGetDeploymentsQuery__
 *
 * To run a query within a React component, call `useGetDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeploymentsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDeploymentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDeploymentsQuery,
    GetDeploymentsQueryVariables
  > &
    (
      | { variables: GetDeploymentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDeploymentsQuery, GetDeploymentsQueryVariables>(
    GetDeploymentsDocument,
    options,
  );
}
export function useGetDeploymentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeploymentsQuery,
    GetDeploymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDeploymentsQuery, GetDeploymentsQueryVariables>(
    GetDeploymentsDocument,
    options,
  );
}
export function useGetDeploymentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeploymentsQuery,
    GetDeploymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeploymentsQuery,
    GetDeploymentsQueryVariables
  >(GetDeploymentsDocument, options);
}
export type GetDeploymentsQueryHookResult = ReturnType<
  typeof useGetDeploymentsQuery
>;
export type GetDeploymentsLazyQueryHookResult = ReturnType<
  typeof useGetDeploymentsLazyQuery
>;
export type GetDeploymentsSuspenseQueryHookResult = ReturnType<
  typeof useGetDeploymentsSuspenseQuery
>;
export type GetDeploymentsQueryResult = Apollo.QueryResult<
  GetDeploymentsQuery,
  GetDeploymentsQueryVariables
>;
export const GetDeploymentsMinDocument = gql`
  query GetDeploymentsMin($status: DeploymentStatus!) {
    getDeployments(status: $status) {
      items {
        id
        jobId
        release {
          semver
        }
      }
    }
  }
`;

/**
 * __useGetDeploymentsMinQuery__
 *
 * To run a query within a React component, call `useGetDeploymentsMinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentsMinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeploymentsMinQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDeploymentsMinQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDeploymentsMinQuery,
    GetDeploymentsMinQueryVariables
  > &
    (
      | { variables: GetDeploymentsMinQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDeploymentsMinQuery,
    GetDeploymentsMinQueryVariables
  >(GetDeploymentsMinDocument, options);
}
export function useGetDeploymentsMinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeploymentsMinQuery,
    GetDeploymentsMinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDeploymentsMinQuery,
    GetDeploymentsMinQueryVariables
  >(GetDeploymentsMinDocument, options);
}
export function useGetDeploymentsMinSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeploymentsMinQuery,
    GetDeploymentsMinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeploymentsMinQuery,
    GetDeploymentsMinQueryVariables
  >(GetDeploymentsMinDocument, options);
}
export type GetDeploymentsMinQueryHookResult = ReturnType<
  typeof useGetDeploymentsMinQuery
>;
export type GetDeploymentsMinLazyQueryHookResult = ReturnType<
  typeof useGetDeploymentsMinLazyQuery
>;
export type GetDeploymentsMinSuspenseQueryHookResult = ReturnType<
  typeof useGetDeploymentsMinSuspenseQuery
>;
export type GetDeploymentsMinQueryResult = Apollo.QueryResult<
  GetDeploymentsMinQuery,
  GetDeploymentsMinQueryVariables
>;
export const GetDeploymentDocument = gql`
  query GetDeployment($id: ID!) {
    getDeployment(id: $id) {
      createTime
      consoleJobUrl
      jobId
      forceInstall
      release {
        semver
        id
        deviceType
        artifacts {
          typeName
          semver
          dependencies {
            typeName
            semver
          }
        }
      }
      attempts {
        startTime
        deployedBy
        tags
        forceInstall
      }
      tags
    }
  }
`;

/**
 * __useGetDeploymentQuery__
 *
 * To run a query within a React component, call `useGetDeploymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeploymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeploymentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDeploymentQuery,
    GetDeploymentQueryVariables
  > &
    (
      | { variables: GetDeploymentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDeploymentQuery, GetDeploymentQueryVariables>(
    GetDeploymentDocument,
    options,
  );
}
export function useGetDeploymentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeploymentQuery,
    GetDeploymentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDeploymentQuery, GetDeploymentQueryVariables>(
    GetDeploymentDocument,
    options,
  );
}
export function useGetDeploymentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeploymentQuery,
    GetDeploymentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeploymentQuery,
    GetDeploymentQueryVariables
  >(GetDeploymentDocument, options);
}
export type GetDeploymentQueryHookResult = ReturnType<
  typeof useGetDeploymentQuery
>;
export type GetDeploymentLazyQueryHookResult = ReturnType<
  typeof useGetDeploymentLazyQuery
>;
export type GetDeploymentSuspenseQueryHookResult = ReturnType<
  typeof useGetDeploymentSuspenseQuery
>;
export type GetDeploymentQueryResult = Apollo.QueryResult<
  GetDeploymentQuery,
  GetDeploymentQueryVariables
>;
export const GetDeviceDeploymentsDocument = gql`
  query GetDeviceDeployments($deploymentId: ID!) {
    getDeviceDeployments(deploymentId: $deploymentId) {
      items {
        id
        deploymentId
        canopyDeviceId
        serialNumber
        status
        downloadStatus
        installStatus
        updatedAt
        states {
          download {
            status
          }
          install {
            status
          }
        }
      }
    }
  }
`;

/**
 * __useGetDeviceDeploymentsQuery__
 *
 * To run a query within a React component, call `useGetDeviceDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceDeploymentsQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetDeviceDeploymentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDeviceDeploymentsQuery,
    GetDeviceDeploymentsQueryVariables
  > &
    (
      | { variables: GetDeviceDeploymentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDeviceDeploymentsQuery,
    GetDeviceDeploymentsQueryVariables
  >(GetDeviceDeploymentsDocument, options);
}
export function useGetDeviceDeploymentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeviceDeploymentsQuery,
    GetDeviceDeploymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDeviceDeploymentsQuery,
    GetDeviceDeploymentsQueryVariables
  >(GetDeviceDeploymentsDocument, options);
}
export function useGetDeviceDeploymentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeviceDeploymentsQuery,
    GetDeviceDeploymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeviceDeploymentsQuery,
    GetDeviceDeploymentsQueryVariables
  >(GetDeviceDeploymentsDocument, options);
}
export type GetDeviceDeploymentsQueryHookResult = ReturnType<
  typeof useGetDeviceDeploymentsQuery
>;
export type GetDeviceDeploymentsLazyQueryHookResult = ReturnType<
  typeof useGetDeviceDeploymentsLazyQuery
>;
export type GetDeviceDeploymentsSuspenseQueryHookResult = ReturnType<
  typeof useGetDeviceDeploymentsSuspenseQuery
>;
export type GetDeviceDeploymentsQueryResult = Apollo.QueryResult<
  GetDeviceDeploymentsQuery,
  GetDeviceDeploymentsQueryVariables
>;
export const GetDeviceTagsDocument = gql`
  query GetDeviceTags($input: GetDeviceTagsInput!) {
    getDeviceTags(input: $input) {
      results {
        tagId
        canopyDeviceId
        serialNumber
        tagName
      }
      count
      next
      prev
    }
  }
`;

/**
 * __useGetDeviceTagsQuery__
 *
 * To run a query within a React component, call `useGetDeviceTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDeviceTagsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDeviceTagsQuery,
    GetDeviceTagsQueryVariables
  > &
    (
      | { variables: GetDeviceTagsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDeviceTagsQuery, GetDeviceTagsQueryVariables>(
    GetDeviceTagsDocument,
    options,
  );
}
export function useGetDeviceTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeviceTagsQuery,
    GetDeviceTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDeviceTagsQuery, GetDeviceTagsQueryVariables>(
    GetDeviceTagsDocument,
    options,
  );
}
export function useGetDeviceTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeviceTagsQuery,
    GetDeviceTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeviceTagsQuery,
    GetDeviceTagsQueryVariables
  >(GetDeviceTagsDocument, options);
}
export type GetDeviceTagsQueryHookResult = ReturnType<
  typeof useGetDeviceTagsQuery
>;
export type GetDeviceTagsLazyQueryHookResult = ReturnType<
  typeof useGetDeviceTagsLazyQuery
>;
export type GetDeviceTagsSuspenseQueryHookResult = ReturnType<
  typeof useGetDeviceTagsSuspenseQuery
>;
export type GetDeviceTagsQueryResult = Apollo.QueryResult<
  GetDeviceTagsQuery,
  GetDeviceTagsQueryVariables
>;
export const AssociateTagWithDeviceDocument = gql`
  mutation AssociateTagWithDevice($input: AssociateTagWithDeviceInput!) {
    associateTagWithDevice(input: $input) {
      deviceTag {
        tagId
        canopyDeviceId
        serialNumber
        tagName
      }
    }
  }
`;
export type AssociateTagWithDeviceMutationFn = Apollo.MutationFunction<
  AssociateTagWithDeviceMutation,
  AssociateTagWithDeviceMutationVariables
>;

/**
 * __useAssociateTagWithDeviceMutation__
 *
 * To run a mutation, you first call `useAssociateTagWithDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateTagWithDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateTagWithDeviceMutation, { data, loading, error }] = useAssociateTagWithDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateTagWithDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssociateTagWithDeviceMutation,
    AssociateTagWithDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssociateTagWithDeviceMutation,
    AssociateTagWithDeviceMutationVariables
  >(AssociateTagWithDeviceDocument, options);
}
export type AssociateTagWithDeviceMutationHookResult = ReturnType<
  typeof useAssociateTagWithDeviceMutation
>;
export type AssociateTagWithDeviceMutationResult =
  Apollo.MutationResult<AssociateTagWithDeviceMutation>;
export type AssociateTagWithDeviceMutationOptions = Apollo.BaseMutationOptions<
  AssociateTagWithDeviceMutation,
  AssociateTagWithDeviceMutationVariables
>;
export const DisassociateTagFromDeviceDocument = gql`
  mutation DisassociateTagFromDevice($input: DisassociateTagFromDeviceInput!) {
    disassociateTagFromDevice(input: $input) {
      ok
    }
  }
`;
export type DisassociateTagFromDeviceMutationFn = Apollo.MutationFunction<
  DisassociateTagFromDeviceMutation,
  DisassociateTagFromDeviceMutationVariables
>;

/**
 * __useDisassociateTagFromDeviceMutation__
 *
 * To run a mutation, you first call `useDisassociateTagFromDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisassociateTagFromDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disassociateTagFromDeviceMutation, { data, loading, error }] = useDisassociateTagFromDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisassociateTagFromDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisassociateTagFromDeviceMutation,
    DisassociateTagFromDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisassociateTagFromDeviceMutation,
    DisassociateTagFromDeviceMutationVariables
  >(DisassociateTagFromDeviceDocument, options);
}
export type DisassociateTagFromDeviceMutationHookResult = ReturnType<
  typeof useDisassociateTagFromDeviceMutation
>;
export type DisassociateTagFromDeviceMutationResult =
  Apollo.MutationResult<DisassociateTagFromDeviceMutation>;
export type DisassociateTagFromDeviceMutationOptions =
  Apollo.BaseMutationOptions<
    DisassociateTagFromDeviceMutation,
    DisassociateTagFromDeviceMutationVariables
  >;
export const GetTagByNameDocument = gql`
  query GetTagByName($tagName: String!) {
    getTagByName(tagName: $tagName) {
      tagId
      tagName
    }
  }
`;

/**
 * __useGetTagByNameQuery__
 *
 * To run a query within a React component, call `useGetTagByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagByNameQuery({
 *   variables: {
 *      tagName: // value for 'tagName'
 *   },
 * });
 */
export function useGetTagByNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTagByNameQuery,
    GetTagByNameQueryVariables
  > &
    (
      | { variables: GetTagByNameQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTagByNameQuery, GetTagByNameQueryVariables>(
    GetTagByNameDocument,
    options,
  );
}
export function useGetTagByNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTagByNameQuery,
    GetTagByNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTagByNameQuery, GetTagByNameQueryVariables>(
    GetTagByNameDocument,
    options,
  );
}
export function useGetTagByNameSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTagByNameQuery,
    GetTagByNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTagByNameQuery, GetTagByNameQueryVariables>(
    GetTagByNameDocument,
    options,
  );
}
export type GetTagByNameQueryHookResult = ReturnType<
  typeof useGetTagByNameQuery
>;
export type GetTagByNameLazyQueryHookResult = ReturnType<
  typeof useGetTagByNameLazyQuery
>;
export type GetTagByNameSuspenseQueryHookResult = ReturnType<
  typeof useGetTagByNameSuspenseQuery
>;
export type GetTagByNameQueryResult = Apollo.QueryResult<
  GetTagByNameQuery,
  GetTagByNameQueryVariables
>;
export const GetDeviceTypesDocument = gql`
  query GetDeviceTypes {
    __type(name: "DeviceTypeName") {
      enumValues {
        name
      }
    }
  }
`;

/**
 * __useGetDeviceTypesQuery__
 *
 * To run a query within a React component, call `useGetDeviceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDeviceTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDeviceTypesQuery,
    GetDeviceTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>(
    GetDeviceTypesDocument,
    options,
  );
}
export function useGetDeviceTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeviceTypesQuery,
    GetDeviceTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>(
    GetDeviceTypesDocument,
    options,
  );
}
export function useGetDeviceTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeviceTypesQuery,
    GetDeviceTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeviceTypesQuery,
    GetDeviceTypesQueryVariables
  >(GetDeviceTypesDocument, options);
}
export type GetDeviceTypesQueryHookResult = ReturnType<
  typeof useGetDeviceTypesQuery
>;
export type GetDeviceTypesLazyQueryHookResult = ReturnType<
  typeof useGetDeviceTypesLazyQuery
>;
export type GetDeviceTypesSuspenseQueryHookResult = ReturnType<
  typeof useGetDeviceTypesSuspenseQuery
>;
export type GetDeviceTypesQueryResult = Apollo.QueryResult<
  GetDeviceTypesQuery,
  GetDeviceTypesQueryVariables
>;
export const GetGroupedArtifactsDocument = gql`
  query GetGroupedArtifacts($deviceTypeName: DeviceTypeName) {
    getGroupedArtifacts(deviceType: $deviceTypeName) {
      groups {
        typeName
        artifacts {
          id
          semver
          typeName
          lastUpdateTime
          createTime
          lastRelease {
            semver
          }
        }
      }
    }
  }
`;

/**
 * __useGetGroupedArtifactsQuery__
 *
 * To run a query within a React component, call `useGetGroupedArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupedArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupedArtifactsQuery({
 *   variables: {
 *      deviceTypeName: // value for 'deviceTypeName'
 *   },
 * });
 */
export function useGetGroupedArtifactsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >(GetGroupedArtifactsDocument, options);
}
export function useGetGroupedArtifactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >(GetGroupedArtifactsDocument, options);
}
export function useGetGroupedArtifactsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >(GetGroupedArtifactsDocument, options);
}
export type GetGroupedArtifactsQueryHookResult = ReturnType<
  typeof useGetGroupedArtifactsQuery
>;
export type GetGroupedArtifactsLazyQueryHookResult = ReturnType<
  typeof useGetGroupedArtifactsLazyQuery
>;
export type GetGroupedArtifactsSuspenseQueryHookResult = ReturnType<
  typeof useGetGroupedArtifactsSuspenseQuery
>;
export type GetGroupedArtifactsQueryResult = Apollo.QueryResult<
  GetGroupedArtifactsQuery,
  GetGroupedArtifactsQueryVariables
>;
export const GetIotJobStatusDocument = gql`
  query GetIotJobStatus($input: IotJobStatusInput!) {
    getIotJobStatus(input: $input) {
      status
      lastUpdatedAt
      isCancellable
    }
  }
`;

/**
 * __useGetIotJobStatusQuery__
 *
 * To run a query within a React component, call `useGetIotJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIotJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIotJobStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIotJobStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIotJobStatusQuery,
    GetIotJobStatusQueryVariables
  > &
    (
      | { variables: GetIotJobStatusQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIotJobStatusQuery, GetIotJobStatusQueryVariables>(
    GetIotJobStatusDocument,
    options,
  );
}
export function useGetIotJobStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIotJobStatusQuery,
    GetIotJobStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIotJobStatusQuery,
    GetIotJobStatusQueryVariables
  >(GetIotJobStatusDocument, options);
}
export function useGetIotJobStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIotJobStatusQuery,
    GetIotJobStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIotJobStatusQuery,
    GetIotJobStatusQueryVariables
  >(GetIotJobStatusDocument, options);
}
export type GetIotJobStatusQueryHookResult = ReturnType<
  typeof useGetIotJobStatusQuery
>;
export type GetIotJobStatusLazyQueryHookResult = ReturnType<
  typeof useGetIotJobStatusLazyQuery
>;
export type GetIotJobStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetIotJobStatusSuspenseQuery
>;
export type GetIotJobStatusQueryResult = Apollo.QueryResult<
  GetIotJobStatusQuery,
  GetIotJobStatusQueryVariables
>;
export const GetReleasesDocument = gql`
  query GetReleases {
    getReleases(limit: 250) {
      items {
        id
        semver
        artifacts {
          semver
          typeName
        }
        deviceType
        isPromoted
        isLatestApproved
        isStable
        isDeployed
      }
    }
  }
`;

/**
 * __useGetReleasesQuery__
 *
 * To run a query within a React component, call `useGetReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReleasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReleasesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReleasesQuery,
    GetReleasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReleasesQuery, GetReleasesQueryVariables>(
    GetReleasesDocument,
    options,
  );
}
export function useGetReleasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReleasesQuery,
    GetReleasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReleasesQuery, GetReleasesQueryVariables>(
    GetReleasesDocument,
    options,
  );
}
export function useGetReleasesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetReleasesQuery,
    GetReleasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetReleasesQuery, GetReleasesQueryVariables>(
    GetReleasesDocument,
    options,
  );
}
export type GetReleasesQueryHookResult = ReturnType<typeof useGetReleasesQuery>;
export type GetReleasesLazyQueryHookResult = ReturnType<
  typeof useGetReleasesLazyQuery
>;
export type GetReleasesSuspenseQueryHookResult = ReturnType<
  typeof useGetReleasesSuspenseQuery
>;
export type GetReleasesQueryResult = Apollo.QueryResult<
  GetReleasesQuery,
  GetReleasesQueryVariables
>;
export const GetStableVersionDocument = gql`
  query GetStableVersion {
    getStableVersion {
      id
      release {
        semver
      }
    }
  }
`;

/**
 * __useGetStableVersionQuery__
 *
 * To run a query within a React component, call `useGetStableVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStableVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStableVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStableVersionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetStableVersionQuery,
    GetStableVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStableVersionQuery, GetStableVersionQueryVariables>(
    GetStableVersionDocument,
    options,
  );
}
export function useGetStableVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStableVersionQuery,
    GetStableVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStableVersionQuery,
    GetStableVersionQueryVariables
  >(GetStableVersionDocument, options);
}
export function useGetStableVersionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetStableVersionQuery,
    GetStableVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetStableVersionQuery,
    GetStableVersionQueryVariables
  >(GetStableVersionDocument, options);
}
export type GetStableVersionQueryHookResult = ReturnType<
  typeof useGetStableVersionQuery
>;
export type GetStableVersionLazyQueryHookResult = ReturnType<
  typeof useGetStableVersionLazyQuery
>;
export type GetStableVersionSuspenseQueryHookResult = ReturnType<
  typeof useGetStableVersionSuspenseQuery
>;
export type GetStableVersionQueryResult = Apollo.QueryResult<
  GetStableVersionQuery,
  GetStableVersionQueryVariables
>;
export const GetTagsDocument = gql`
  query GetTags($input: GetTagsInput!) {
    getTags(input: $input) {
      results {
        tagId
        tagName
      }
      count
      next
      prev
    }
  }
`;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTagsQuery(
  baseOptions: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables> &
    ({ variables: GetTagsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(
    GetTagsDocument,
    options,
  );
}
export function useGetTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTagsQuery,
    GetTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(
    GetTagsDocument,
    options,
  );
}
export function useGetTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTagsQuery,
    GetTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(
    GetTagsDocument,
    options,
  );
}
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<
  typeof useGetTagsSuspenseQuery
>;
export type GetTagsQueryResult = Apollo.QueryResult<
  GetTagsQuery,
  GetTagsQueryVariables
>;
